module.exports = __webpack_public_path__ + "img/m-banner-xzdvxwdm-fr-FR.091bf961.jpg";